/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-bitwise */
export default class MapUtils {
  private static INCHES_PER_UNIT: any = { m: 39.37, dd: 4374754 };

  private static DOTS_PER_INCH = 90.714; // 72;

  static getScaleFromResolution(resolution: number, units: string, optRound: boolean): number {
    let scale = this.INCHES_PER_UNIT[units] * this.DOTS_PER_INCH * resolution;
    if (optRound) {
      scale = Math.round(scale);
    }
    return scale;
  }

  static getResolutionFromScale(scale: number, units: string): number {
    const resolution = scale / (this.INCHES_PER_UNIT[units] * this.DOTS_PER_INCH);
    return resolution;
  }

  static replaceSvgColor(svgData: string, fillcolor: string | undefined,
    strokecolor: string | undefined, strokeWidth: number | undefined): string {
    const fillHex = fillcolor && fillcolor.length > 0 ? MapUtils.rgba2hex(fillcolor) : '';
    const fillOpacity = fillcolor && fillcolor.length > 0 ? MapUtils.rgba2opacity(fillcolor) : '';
    const strokeHex = strokecolor && strokecolor.length > 0 ? MapUtils.rgba2hex(strokecolor) : '';
    const strokeOpacity = strokecolor && strokecolor.length > 0 ? MapUtils.rgba2opacity(strokecolor) : '';
    const width = strokeWidth !== undefined && strokeWidth !== null ? String(strokeWidth) : '';

    if (fillHex.length > 0) {
      svgData = svgData.replaceAll(/param\(fill\)(\s*[#\w.]*)?/g, fillHex);
      svgData = svgData.replaceAll(/param\(fill-opacity\)(\s*[\d.]*)?/g, fillOpacity);
    }
    if (strokeHex.length > 0) {
      svgData = svgData.replaceAll(/param\(stroke\)(\s*[#\w.]*)?/g, strokeHex);
      svgData = svgData.replaceAll(/param\(outline\)(\s*[#\w.]*)?/g, strokeHex);
      svgData = svgData.replaceAll(/param\(stroke-opacity\)(\s*[\d.]*)?/g, strokeOpacity);
      svgData = svgData.replaceAll(/param\(outline-opacity\)(\s*[\d.]*)?/g, strokeOpacity);
    }
    if (width.length > 0) {
      svgData = svgData.replaceAll(/param\(stroke-width\)(\s*\d*)?/g, width);
      svgData = svgData.replaceAll(/param\(outline-width\)(\s*\d*)?/g, width);
    }
    return svgData;
  }

  static rgba2hex(orig:any):string {
    let a;
    const rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
    const alpha = (rgb && rgb[4] || '').trim();
    const hex = rgb
      ? `#${(rgb[1] | 1 << 8).toString(16).slice(1)
      }${(rgb[2] | 1 << 8).toString(16).slice(1)
      }${(rgb[3] | 1 << 8).toString(16).slice(1)}` : orig;

    if (alpha !== '') {
      a = alpha;
    } else { a = '01'; }

    // hex = hex + a;
    return hex;
  }
  static rgbaChangeOpacity(orig:any,newOpacity:number):string {
    let a;
    const rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
    return `rgba(${rgb[1]},${rgb[2]},${rgb[3]},${newOpacity})`
  }

  static rgba2opacity(orig:any):string {
    let a;
    const rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
    const alpha = (rgb && rgb[4] || '').trim();
    const hex = rgb
      ? (rgb[1] | 1 << 8).toString(16).slice(1)
                + (rgb[2] | 1 << 8).toString(16).slice(1)
                + (rgb[3] | 1 << 8).toString(16).slice(1) : orig;

    if (alpha !== '') { a = alpha; } else { a = '1'; }

    // hex = hex + a;

    return a;
  }
}
